import { render, staticRenderFns } from "./xdslTrafficLight.vue?vue&type=template&id=5fb15dc4&scoped=true&"
import script from "./xdslTrafficLight.vue?vue&type=script&lang=js&"
export * from "./xdslTrafficLight.vue?vue&type=script&lang=js&"
import style0 from "./xdslTrafficLight.vue?vue&type=style&index=0&id=5fb15dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb15dc4",
  null
  
)

export default component.exports